export default __webpack_public_path__ + "static/media/jon-tyson-rbz1hVh7_LM-unsplash.19fe913f.jpg";